import { Box, Stack, Typography } from "@mui/material";
import Head from "next/head";
import Title from "../components/Title";
import Footer from "../components/Footer";

import { motion } from "framer-motion";
import Navbar from "../components/Navbar";
import Avatar from "../components/Avatar";
import StickyWhatsapp from "../components/StickyWhatsapp";
import HeroEnquiryForm from "../components/HeroEnquiryForm";
const textAni = {
  offscreen: { y: 20, opacity: 0 },
  onscreen: {
    y: 0,
    opacity: 1,
  },
};
const fadeInUpL = {
  offscreen: {
    y: 100,
    opacity: 0,
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      duration: 0.6,
    },
  },
};
const fadeInUpR = {
  offscreen: {
    y: -100,
    opacity: 0,
  },
  onscreen: {
    y: 0,
    opacity: 1,
    transition: {
      type: "spring",
      duration: 0.6,
    },
  },
};

const txtAni = {
  offscreen: { y: 100, opacity: 0 },
  onscreen: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", bounce: 0.1, duration: 0.6 },
  },
};
const teamAni = {
  offscreen: { y: 50, opacity: 0 },
  onscreen: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", bounce: 0.1, duration: 0.6 },
  },
};
const about = () => {
  const rdTeam = [
    {
      img: "/pop-out-avatars/vimal.png",
      name: "Dr. Vimal PhD",
      color: "#ff5353",
      designation: `Information Management`,
    },
    {
      img: "/pop-out-avatars/muthukumar.png",
      name: "Dr. Vr Muthukumar PhD",
      color: "#ad00ff",
      designation: "Solar Energy",
    },
    {
      img: "/pop-out-avatars/sivabalan.png",
      name: "Dr. Sivabalan PhD",
      color: "#1BDE9C",
      designation: "Cyber Security",
    },
  ];
  const softTeam = [
    {
      img: "/pop-out-avatars/hemnath.png",
      color: "#38b7ff",
      name: "Hemnath",
      designation: "Full-Stack Engineer",
    },
    {
      img: "/pop-out-avatars/yasmin-roja.png",
      name: "Yasmin Roja",
      color: "#fc03b1",
      designation: "Software Engineer",
    },
    {
      img: "/pop-out-avatars/logesh.png",
      name: "Logesh",
      color: "#02d46b",
      designation: "Frontend Engineer",
    },
    {
      img: "/pop-out-avatars/denesh.png",
      name: "Denesh Babu",
      color: "#02d46b",
      designation: "Frontend Engineer",
    },
    {
      img: "/pop-out-avatars/thinesh.png",
      name: "Thinesh Kumar",
      color: "#02d46b",
      designation: "Software Engineer",
    },
    {
      img: "/pop-out-avatars/ciranjivi.png",
      name: "Ciranjivi",
      color: "#02d46b",
      designation: "Software Engineer",
    },
  ];

  return (
    <Box 
    sx={{
    }}>
    {/* <StarsCanvas /> */}
    
    <Head>
    <title>About Us | Techbrain Networks</title>
    <meta name="description" content="Learn about Techbrain Networks, our mission, vision, and values. Discover our journey as a global leader in technology innovation across various industries." />
    
    {/* <!-- Open Graph / Facebook --> */}
    <meta property="og:title" content="About Us | Techbrain Networks" />
    <meta property="og:description" content="Learn about Techbrain Networks, our mission, vision, and values. Discover our journey as a global leader in technology innovation across various industries." />
    <meta property="og:url" content="https://www.techbrainnetworks.com/about" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="About Techbrain Networks" />
    <meta property="og:site_name" content="Techbrain Networks" />
    <meta property="og:locale" content="en_US" />

    {/* <!-- Twitter --> */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="About Us | Techbrain Networks" />
    <meta name="twitter:description" content="Discover the mission and vision of Techbrain Networks, a global leader in technology innovation." />
    <meta name="twitter:url" content="https://www.techbrainnetworks.com/about" />
    <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta name="twitter:image:alt" content="About Techbrain Networks" />

    {/* <!-- Additional Meta Tags --> */}
    <meta name="keywords" content="Techbrain Networks, About Us, Mission, Vision, Technology Leader" />
    <meta name="author" content="Techbrain Networks" />
    <meta name="robots" content="index, follow" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <meta name="theme-color" content="#000000" />
    <meta property="og:updated_time" content={new Date().toISOString()} />

    {/* Favicon and Fonts */}
    <link rel="icon" href="/favicon.png" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=YourFontFamily:wght@400;700&display=swap" rel="stylesheet" />
</Head>


      <Navbar color="#fff"   />
      <StickyWhatsapp link={"https://api.whatsapp.com/send?phone=918754906714"} />
      {/* section 1 - home */}
      <Box
        className="worksans"
        sx={{
          // bgcolor: "#7624F3",
          width: "100%",
          display: "flex",
          justifyContent: ["center"],
          alignItems: "center",
          flexDirection: "column",
          p: [1, 0],
          backgroundImage: [`url(./circletop3.png),url(./circletop.png)`],
          backgroundPosition: [
            " -5% bottom, right -10%",
            " left bottom, right -20%",
            " left bottom, right -20%",
            " left bottom, right -20%",
            " left bottom, right -20%",
          ],
          backgroundRepeat: "no-repeat",
          backgroundSize: [
            "200px,200px",
            "250px,250px",
            "300px,300px",
            "300px,300px",
            "400px,400px",
          ],
          height: ["100vh"],
          color: "#fff",
          position: "relative",
        }}
      >
        <Stack
          direction="column"
          alignItems="center"
          component={motion.div}
          initial={"offscreen"}
          whileInView={"onscreen"}
          viewport={{ once: true, amount: 0.5 }}
          transition={{ staggerChildren: 0.2 }}
          gap={{ xs: 2, sm: 3 }}
        >
          <Typography
            width={{ xs: "100%", sm: "70%", md: "80%", lg: "85%", xl: "75%" }}
            variants={txtAni}
            className="worksans"
            component={motion.h1}
            sx={{
              fontSize: ["35px", "50px", "60px", "75px", "90px"],
              textAlign: "center",
              background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
              backgroundClip: "text",
              textFillColor: "transparent",
              fontWeight: [800],
              mb: { xs: 1 },
              lineHeight: ["35px", "55px", "65px", "105px"],
            }}
          >
            About Us
          </Typography>
          <Typography
            width={{ xs: "100%", sm: "80%", md: "85%", lg: "85%", xl: "85%" }}
            variants={textAni}
            className="worksans"
            viewport={{ once: true, amount: 0.5 }}
            initial={"offscreen"}
            whileInView={"onscreen"}
            component={motion.h2}
            transition={{ delay: 0.5 }}
            sx={{
              fontSize: ["20px", "30px", "40px", "45px", "55px"],
              textAlign: "center",
              color: "#fff",
              lineHeight: ["25px", "35px", "50px", "45px", "60px"],
              fontWeight: [800],
              mb: { xs: 1 },
            }}
          >
            Techbrain Networks is a  leading <span  style={{background: 'linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)',WebkitBackgroundClip: 'text',WebkitTextFillColor: 'transparent',backgroundClip: 'text',textFillColor: 'transparent'}}>Software Product Development</span> company
            that specializes in <span  style={{background: 'linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)',WebkitBackgroundClip: 'text',WebkitTextFillColor: 'transparent',backgroundClip: 'text',textFillColor: 'transparent'}}> AI, IoT, Big data,</span><span  style={{background: 'linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)',WebkitBackgroundClip: 'text',WebkitTextFillColor: 'transparent',backgroundClip: 'text',textFillColor: 'transparent'}}> Blockchain, Cloud Computing,</span>
            <span  style={{background: 'linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)',WebkitBackgroundClip: 'text',WebkitTextFillColor: 'transparent',backgroundClip: 'text',textFillColor: 'transparent'}}> Quantum Computing  and Digital Marketing.</span>
          </Typography>
        </Stack>
      </Box>

      {/* OUR section */}
      <Stack
        direction={{ xs: "column-reverse", md: "row" }}
        px={{ xs: 2, sm: 3, md: 6, xl: 11 }}
        sx={{
          zIndex: 21
        }}
        py={{ xs: 2, sm: 3, md: 4, xl: 8 }}
        alignItems="center"
        justifyContent="space-evenly"
      >
        <Stack
          direction="column"
          width={{ xs: "100%", sm: "85%", md: "55%", xl: "60%" }}
          initial={"offscreen"}
          whileInView={"onscreen"}
          viewport={{ once: true, amount: 0.5 }}
          component={motion.div}
          variants={fadeInUpL}
          gap={{ xs: 1, sm: 2, md: 2, xl: 3 }}
        >
          <Stack
            direction="row"
            height={"max-content"}
            alignItems="center"
            gap={{ xs: 1, md: 2 }}
          >
            <Typography
              fontWeight="600"
              sx={{
                fontSize: ["8rem", "8rem", "9rem", "9rem", "16rem"],
                textAlign: "center",
                background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                lineHeight: ["1", "1", ".8"],
              }}
            >
              O
            </Typography>

            <Typography
              sx={{
                fontSize: [".75rem", ".99rem", ".8rem", "1rem", "1.4rem"],
                color: '#fff'
              }}
            >
              "{" "}
              <Typography
                sx={{
                  fontSize: ["1.1rem", "1.3rem", "1.2rem", "1.2rem", "1.6rem"],
                  color: "orange",
                  fontWeight: "600",
                  display: "inline",
                  color:'#FF512F',
                }}
              >
                Vision:
              </Typography>{" "}
              We aspire to be a global leader in technology innovation, setting new benchmarks for excellence. Our goal is to create a future where technology elevates the quality of life, fosters sustainability, and drives growth and collaboration on a global scale, shaping a smarter, more connected world.
            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={{ xs: 1, md: 2 }}>
            <Typography
              fontWeight="600"
              sx={{
                fontSize: ["8rem", "8rem", "9rem", "9rem", "16rem"],
                textAlign: "center",
                background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                lineHeight: ["1", "1", ".8"],
              }}
            >
              U
            </Typography>

            <Typography
              sx={{
                fontSize: [".75rem", ".99rem", ".8rem", "1rem", "1.4rem"],
                color: '#fff'
              }}
            >
              "{" "}
              <Typography
                sx={{
                  fontSize: ["1.1rem", "1.3rem", "1.2rem", "1.2rem", "1.6rem"],
                  color: "orange",
                  fontWeight: "600",
                  display: "inline",
                  color:'#FF512F',
                }}
              >
                Mission:
              </Typography>{" "}
               We are dedicated to empowering businesses and individuals globally with cutting-edge technology solutions that drive innovation, efficiency, and sustainability. Our commitment is to deliver reliable, scalable, and secure products across diverse industries, enabling our clients to excel in a rapidly evolving digital landscape.            </Typography>
          </Stack>
          <Stack direction="row" alignItems="center" gap={{ xs: 1, md: 2 }}>
            <Typography
              fontWeight="600"
              sx={{
                fontSize: ["8rem", "8rem", "9rem", "9rem", "16rem"],
                textAlign: "center",
                background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
                backgroundClip: "text",
                textFillColor: "transparent",
                lineHeight: ["1", "1", ".8"],
              }}
            >
              R
            </Typography>

            <Typography
              sx={{
                fontSize: [".75rem", ".99rem", ".8rem", "1rem", "1.4rem"],
                color: '#fff'
              }}
            >
              "{" "}
              <Typography
                sx={{
                  fontSize: ["1.1rem", "1.3rem", "1.2rem", "1.2rem", "1.6rem"],
                  color: "orange",
                  fontWeight: "600",
                  display: "inline",
                  color:'#FF512F',
                }}
              >
                Passion:
              </Typography>{" "}
              Our passion for research and development fuels our relentless pursuit of elegant solutions to complex challenges. Every product and service reflects our commitment to innovation and excellence. We push the boundaries of what's possible to inspire the future of technology and build a world where possibilities are limitless."               </Typography>
          </Stack>
        </Stack>
        <Stack
          direction="column"
          width={{ xs: "100%", sm: "50%", md: "40%", lg: "38%", xl: "38%" }}
          initial={"offscreen"}
          whileInView={"onscreen"}
          viewport={{ once: true, amount: 0.5 }}
          component={motion.div}
          variants={fadeInUpR}
        >
           <motion.img 
            alt="our"
            src="/our-img.png"
            style={{
              height: "auto",
              width: "100%",
              zIndex:'1'
            }}
          />
        </Stack>
      </Stack>

      {/* Team section */}
      <Stack
        direction="column"
        py={{ xs: 2, sm: 3, md: 4 }}
        pb={{ xs: 5, sm: 6, md: 8 }}
        alignItems="center"
        justifyContent="space-evenly"
        gap={{ xs: 1, sm: 3, md: 4, lg: 4.5, xl: 7 }}
        position="relative"
        sx={{
          px: [3, 5, 5, 10, 5],
        }}
        overflow="hidden"
      >
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: -40 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            width: [".9rem", "1.1rem", "1.4rem", "1.5rem", "2rem"],
            height: [".9rem", "1.1rem", "1.4rem", "1.5rem", "2rem"],
            position: "absolute",
            right: ["5%"],
            top: ["10%", "10%"],
          }}
        >
          <img alt="icon" src="/star1.png" style={{ width: "100%" }} />
        </Stack>
        {/* star */}
        <Stack
          component={motion.div}
          animate={{ x: -40 }}
          transition={{
            duration: 2,
            repeat: Infinity,
            repeatType: "reverse",
          }}
          sx={{
            width: [".9rem", "1.1rem", "1.4rem", "1.5rem", "2rem"],
            height: [".9rem", "1.1rem", "1.4rem", "1.5rem", "2rem"],
            position: "absolute",
            right: ["5%"],
            bottom: ["2%"],
          }}
        >
          <img alt="icon" src="/star2.png" style={{ width: "100%" }} />
        </Stack>
        {/* star 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            left: ["10%"],
            top: ["40%"],
          }}
        >
          <img alt="icon" src="/star4.png" style={{ width: "100%" }} />
        </Stack>
        {/* star 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 10,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            height: ["1rem", "1rem", "1.5rem", "1.8rem", "2rem"],
            position: "absolute",
            left: ["5%"],
            top: ["70%"],
          }}
        >
          <img alt="icon" src="/star3d.png" style={{ width: "100%" }} />
        </Stack>
        {/* sqr 360 */}
        <Stack
          component={motion.div}
          animate={{ rotate: 360 }}
          transition={{
            duration: 7,
            repeat: Infinity,
            ease: "linear",
          }}
          sx={{
            width: ["2rem", "3rem", "3.5rem", "4rem", "5rem"],
            height: ["2rem", "3rem", "3.5rem", "4rem", "5rem"],
            position: "absolute",
            right: ["-1rem", "-1.5rem", "-1.7rem", "-2rem", "-2.5rem"],
            bottom: ["50%"],
          }}
        >
          <img alt="icon" src="/square.png" style={{ width: "100%" }} />
        </Stack>
        <Stack
          sx={{
            height: ["5rem", "6rem", "7rem", "8rem", "10rem"],
            position: "absolute",
            left: ["0"],
            top: ["50%"],
          }}
        >
          <img alt="icon" src="/dotL-o.png" style={{ height: "100%" }} />
        </Stack>
        <Stack
          sx={{
            height: ["5rem", "6rem", "7rem", "8rem", "10rem"],
            position: "absolute",
            right: ["0"],
            bottom: ["10%"],
          }}
        >
          <img alt="icon" src="/dotR-y.png" style={{ height: "100%" }} />
        </Stack>
        <Box sx={{width:'100%',height:['35vh','40vh','40vh','80vh'],backgroundSize:['none','cover','none'],backgroundPosition:'center',px:'0rem'}}  className="map">
        </Box>
        <Stack
          direction="row"
          mt={{ xs: 2, md: 5 }}
          flexWrap="wrap"
          alignItems="center"
          py={{ xs: "1rem", sm: 0 }}
          mb={{ xs: 4, sm: 7, lg: 8 }}
          gap={{ xs: 2, sm: 3, md: 3.5, lg: 4 }}
          justifyContent={{ xs: "space-evenly", sm: "center" }}
        >
          <Stack
            direction="column"
            alignItems="center"
            gap={{ xs: 1, md: 2, lg: 3, xl: 4 }}
            initial={"offscreen"}
            whileInView={"onscreen"}
            viewport={{ once: true, amount: 1 }}
            transition={{ staggerChildren: 0.2 }}
            component={motion.div}
          >
            <Avatar img={"/pop-out-avatars/ramkumar.png"} />
            <Stack
                        width={{ xs: "100%", sm: "80%", md: "85%", lg: "85%", xl: "85%" }}

              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Typography
                component={motion.p}
                variants={txtAni}
                sx={{
                  fontSize: [".9rem", "1rem", "1rem", "1rem", "1.3rem"],
                  textAlign: "center",
                  letterSpacing: "0.08em",
                  mb: [".3rem", ".45rem", ".45rem", ".45rem", ".75rem"],
                  color: '#fff'
                }}
                className="worksans"
              >
                {`We are revolutionizing the future of technology with 480 innovative products spanning 24 industries. Starting in 2027, our solutions will reach 30 countries, transforming industries and improving lives. Our mission is to make advanced technology accessible to all, creating a global impact and shaping a brighter future.`}
              </Typography>
              <Typography
                component={motion.p}
                variants={teamAni}
                sx={{
                  fontSize: ["1rem", "1.5rem", "1.5rem", "1.5rem", "2rem"],
                  textAlign: "center",
                  color: "#563DCC",
                  background: "linear-gradient(91.83deg, #FF512F 0%, #DD2476 100%)",
                  backgroundClip: "text",
                  textFillColor: "transparent",
                  fontWeight: 600,
                  lineHeight: "normal",
                  mb: [".3rem", ".3rem"],
                }}
              >
                Ramkumar Arunachalam
              </Typography>
              <Typography
                component={motion.p}
                variants={teamAni}
                sx={{
                  fontSize: [".8rem", ".8rem", ".7rem", ".85rem", "1rem"],
                  textAlign: "center",
                  lineHeight: "normal",
                  color: '#fff'
                }}
              >
                Founder of Techbrain Networks
              </Typography>
            </Stack>
          </Stack> 
        </Stack>
      </Stack>


      {/* form */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: ["column"],
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(91.83deg, #080f25 0%, #080f25 100%)",
          gap: ["1.5rem", "3rem", "2rem", "3rem"],
          py: ["4rem", "4.2rem", "2.8rem", "4rem", "8rem"],
          px: ["1rem", "1.2rem", "1.8rem", "4rem", "5rem"],
          color: "#000",
        }}
      >
        <HeroEnquiryForm heroPage />
      </Box>
      <Box
        sx={{
          position: "relative",
          zIndex: 21,
        }}
      >
        <Footer />
        </Box>
    </Box>
  );
};

export default about;
